<mat-card>
  <mat-card-content>
    <div class="subtitle">
      <p>
        Personas are used to create AI-Generated reviewers that can inspect documents and provide comments. They are
        visible to your team, under “Reviewers” tab to use.
      </p>
      <button mat-fab extended (click)="showCreateUserCard()" data-test-id="admin-personas-create-persona">
        <mat-icon>add_circle</mat-icon>Create a new persona
      </button>
    </div>
    <mat-slide-toggle
      [checked]="showHidden"
      (change)="onShowHiddenChange()"
      class="show-hidden-toggle"
      data-test-id="admin-personas-show-hidden-toggle">
      Show Hidden Personas
    </mat-slide-toggle>
    <div class="persona-entry">
      <mat-card *ngFor="let persona of filteredPersonas" [class.hidden-persona]="persona.is_hidden" [attr.data-test-id]="'admin-personas-list-card-' + persona.name">
        <mat-card-content>
          <p class="persona-header">{{ persona.name }}</p>
        </mat-card-content>
        <mat-card-content>
          <p class="persona-details">{{ persona.summary }}</p>
        </mat-card-content>
        <mat-card-content class="flex-pin-right">
          <button mat-icon-button [matMenuTriggerFor]="matMenu" [attr.data-test-id]="'admin-personas-card-menu-btn-' + persona.name">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #matMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="showEditPersona(persona)" [attr.data-test-id]="'admin-personas-card-edit-btn-' + persona.name">Edit</button>
            <button mat-menu-item (click)="togglePersonaVisibility(persona)" [attr.data-test-id]="'admin-personas-card-toggle-btn-' + persona.name">
              {{ persona.is_hidden ? 'Unhide' : 'Hide' }}
            </button>
            <button mat-menu-item (click)="deletePersona(persona)" [attr.data-test-id]="'admin-personas-card-delete-btn-' + persona.name">Delete</button>
          </mat-menu>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-card-content>
</mat-card>
